import { render, staticRenderFns } from "./MonthlyServiceChargeTable.vue?vue&type=template&id=72be64d4&scoped=true&"
import script from "./MonthlyServiceChargeTable.vue?vue&type=script&lang=js&"
export * from "./MonthlyServiceChargeTable.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyServiceChargeTable.vue?vue&type=style&index=0&id=72be64d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be64d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAlert,VCard,VCardTitle,VChip,VCol,VDataTable,VDivider,VIcon,VPagination,VProgressLinear})
